import React from 'react';
import { useSelectedEnsenanzaId } from '../../graphql/hooks/hooks';
// nodejs library that concatenates classes
//import classNames from 'classnames';
// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';
import Slide from '@material-ui/core/Slide';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
// @material-ui/icons
import Close from '@material-ui/icons/Close';
// core components
import GridContainer from '../UI/Grid/GridContainer';
import GridItem from '../UI/Grid/GridItem';
import Button from '../UI/CustomButtons/Button';

import sectionDelStyle from '../../assets/jss/coscef/views/articuloSections/sectionDelStyle';

const useStyles = makeStyles(sectionDelStyle);
function Transition(props) {
  return <Slide direction='down' {...props} />;
}

const EnseñanzaDel = (props) => {
  const classes = useStyles();

  const selectedEnsenanzaId = useSelectedEnsenanzaId();

  return (
    <GridContainer>
      <GridItem xs={12} sm={6} md={6} lg={4}>
        <Dialog
          classes={{
            root: classes.modalRoot,
            paper: classes.modal + ' ' + classes.modalSmall,
          }}
          open={props.show}
          TransitionComponent={Transition}
          keepMounted
          onClose={props.close}
          aria-labelledby='small-modal-slide-title'
          aria-describedby='small-modal-slide-description'
        >
          <DialogTitle
            id='small-modal-slide-title'
            disableTypography
            className={classes.modalHeader}
          >
            <Button
              simple
              className={classes.modalCloseButton}
              key='close'
              aria-label='Close'
              onClick={props.close}
            >
              {' '}
              <Close className={classes.modalClose} />
            </Button>
          </DialogTitle>
          <DialogContent
            id='small-modal-slide-description'
            className={classes.modalBody}
          >
            <h5 className={classes.title + ' ' + classes.textCenter}>
              ¿Esta seguro que quiere eliminar esta enseñanza?
            </h5>
          </DialogContent>
          <DialogActions
            className={classes.modalFooter + ' ' + classes.modalFooterCenter}
          >
            <Button color='youtube' onClick={props.close}>
              No
            </Button>{' '}
            <Button
              color='success'
              onClick={() => props.removeEnsenanza(selectedEnsenanzaId)}
            >
              Si
            </Button>
          </DialogActions>
        </Dialog>
      </GridItem>
    </GridContainer>
  );
};

export default EnseñanzaDel;
